// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-charts[data-v-02ad7961]{margin-top:30px}@media screen and (max-width:768px){.tile-container[data-v-02ad7961]{padding-left:0;padding-right:0;margin-left:-5px;margin-right:-5px;width:calc(100% + 10px)}}@media screen and (max-width:991px){.tile-container+.tile-container[data-v-02ad7961]{margin-top:30px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
